"use strict";
var mainImg = document.querySelector("#largeImg");
var listUl = document.querySelector("#thumbs");
listUl.addEventListener("click", function(e) {
    var imgEvent = e.target;
    var imgLink = imgEvent.closest("A");
    if (!imgLink) return;
    e.preventDefault();
    mainImg.src = imgLink.href;
});

//# sourceMappingURL=index.b09d47ee.js.map
